module.exports = __webpack_public_path__ + "img/index-3-pic06@2x.52eb71ec.png";